import { SHIPPING_CONDITION_CODE } from '../../../../../../shared/constants/shipping-conditions-codes';
import { delivery } from './delivery/config';

export const admixtures = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: delivery,
};
